import { render, staticRenderFns } from "./home_group.vue?vue&type=template&id=fc3edc2a&scoped=true"
import script from "./home_group.vue?vue&type=script&lang=js"
export * from "./home_group.vue?vue&type=script&lang=js"
import style0 from "./home_group.vue?vue&type=style&index=0&id=fc3edc2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3edc2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc3edc2a')) {
      api.createRecord('fc3edc2a', component.options)
    } else {
      api.reload('fc3edc2a', component.options)
    }
    module.hot.accept("./home_group.vue?vue&type=template&id=fc3edc2a&scoped=true", function () {
      api.rerender('fc3edc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_group.vue"
export default component.exports